<template>
    <el-button @click="myClick" :type="btnType">{{ btnTxt }}</el-button>
</template>
<script>
import _ from 'lodash'
export default {
    props: {
        btnTxt: {
            type: [String],
            default: '提交'
        },
        btnType:{
              type: [String],
            default: 'primary'
        }
    },
    data() {
        return {};
    },
    methods: {
        myClick: _.debounce(function () {
            this.$emit('debounceclick');
        }, 500)
        // debounceclick(){
        //     console.log(111);
        //     this.$emit('debounceclick');
        // }
    }
};
</script> 
<style scoped>
</style>